import { DropDown } from "@shared/interfaces";

export const DISTRESSORS: DropDown[] = [
  { value: "is_court_order", label: "Pre-Foreclosures - Court Order" },
  { value: "is_final_judgment", label: "Pre-Foreclosures - Final Judgement" },
  { value: "is_lis_pendens", label: "Pre-Foreclosures - Lis Pendens", group: "Pre-Foreclosures" },
  { value: "is_notice_of_default", label: "Pre-Foreclosures - Notice of Default" },
  { value: "is_notice_of_foreclosure", label: "Pre-Foreclosures - Notice of Foreclosure" },
  { value: "is_recent_deliquent", label: "Tax Delinquent Properties" },
  { value: "is_probate_properties", label: "Probate Properties" },
  { value: "is_pre_probate", label: "Pre-Probate" },
  { value: "is_divorce_property", label: "Divorce Properties" },
  { value: "is_bankruptcy_property", label: "Bankruptcy Properties" },
  { value: "is_inheritance_property", label: "Inheritance Properties" },
  { value: "is_hoa_lien", label: "HOA Lien" },
  { value: "is_other_lien", label: "Liens (Mechanic's, Utility)" },
  { value: "is_judgment_liens", label: "Judgment Liens" },
  { value: "is_state_tax", label: "State Tax Lien" },
  { value: "is_federal_lien", label: "Federal Lien" },
  { value: "is_eviction", label: "Eviction" },
  { value: "is_vacant_property", label: "Vacant Properties" },
  { value: "is_zombie_property", label: "Zombie Properties" },
  { value: "is_short_term_loan", label: "Short Term Loan" },
  { value: "is_absentee_owners", label: "Absentee Owners" },
  { value: "is_oos_owners", label: "Out-of-State Owners" },
  { value: "is_senior_homeowners", label: "Senior Homeowners" },
  { value: "is_low_income", label: "Low Income" },
  { value: "is_bad_credit", label: "Bad Credit" },
  { value: "is_free_and_clear", label: "Free and Clear" },
  { value: "is_estate_sales", label: "Estate Sales" },
  { value: "is_high_equity", label: "High Equity Properties" },
  { value: "is_tired_landlord", label: "Tired Landlord" },
  { value: "is_criminal_felony", label: "Criminal Felony" },
  { value: "distressors_not_defined", label: "Not Defined", hideForPreview: true },
];

export const DISTRESSORS_GROUP = [
  { value: "is_court_order", label: "Court Order", group: "Pre-Foreclosures" },
  { value: "is_final_judgment", label: "Final Judgement", group: "Pre-Foreclosures" },
  { value: "is_lis_pendens", label: "Lis Pendens", group: "Pre-Foreclosures" },
  { value: "is_notice_of_default", label: "Notice of Default", group: "Pre-Foreclosures" },
  { value: "is_notice_of_foreclosure", label: "Notice of Foreclosure", group: "Pre-Foreclosures" },

  { value: "is_low_income", label: "Low Income", group: "Economic" },
  { value: "is_bad_credit", label: "Bad Credit", group: "Economic" },
  { value: "is_short_term_loan", label: "Short Term Loan", group: "Economic" },
  { value: "is_senior_homeowners", label: "Senior Homeowners", group: "Economic" },
  { value: "is_high_equity", label: "High Equity Properties", group: "Economic" },
  { value: "is_estate_sales", label: "Estate Sales", group: "Economic" },

  { value: "is_judgment_liens", label: "Judgment Liens", group: "Legal/Financial" },
  { value: "is_bankruptcy_property", label: "Bankruptcy Properties", group: "Legal/Financial" },
  { value: "is_state_tax", label: "State Tax Lien", group: "Legal/Financial" },
  { value: "is_recent_deliquent", label: "Tax Delinquent Properties", group: "Legal/Financial" },
  { value: "is_federal_lien", label: "Federal Lien", group: "Legal/Financial" },
  { value: "is_other_lien", label: "Liens (Mechanic's, Utility)", group: "Legal/Financial" },
  { value: "is_eviction", label: "Eviction", group: "Legal/Financial" },
  { value: "is_criminal_felony", label: "Criminal Felony", group: "Legal/Financial" },
  { value: "is_inheritance_property", label: "Inheritance Properties", group: "Legal/Financial" },
  { value: "is_hoa_lien", label: "HOA Lien", group: "Legal/Financial" },

  { value: "is_divorce_property", label: "Divorce Properties", group: "Social" },
  { value: "is_oos_owners", label: "Out-of-State Owners", group: "Social" },
  { value: "is_absentee_owners", label: "Absentee Owners", group: "Social" },
  { value: "is_tired_landlord", label: "Tired Landlord", group: "Social" },

  { value: "is_zombie_property", label: "Zombie Properties", group: "Others" },
  { value: "is_vacant_property", label: "Vacant Properties", group: "Others" },
  { value: "is_probate_properties", label: "Probate Properties", group: "Others" },
  { value: "is_pre_probate", label: "Pre-Probate", group: "Others" },
  { value: "is_free_and_clear", label: "Free and Clear", group: "Others" },
];

export const OWNER_OCCUPIED_DATA: DropDown[] = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "All", value: "All" },
];

export const SELECT_INPUT_FIELDS = ["property_type", "owner_occupied"];
export const TAGGED_INPUT_FIELDS = ["counties", "states", "zips", "property_type", "property_zips"];

export const OWNER_OCCUPIED_VALUES = OWNER_OCCUPIED_DATA.map((item) => item.value);
